<!--
 * @Author: your name
 * @Date: 2021-11-08 14:53:46
 * @LastEditTime: 2021-11-19 17:26:17
 * @LastEditors: Please set LastEditors
 * @Description: 用户注册服务协议
 * @FilePath: \h5-vip\src\pages\CreditCard\khAgreement.vue
-->
<template>
	<div class="app-container">
		<div class="agreement" v-html="html"></div>
	</div>
</template>

<script>
	import {
		JSBkhRegistrationAgreement
	} from "@/api/index"
	export default {
		name: "",
		data() {
			return {
				html: "",
			};
		},
		created() {
			this.getagreement(61)
		},
		methods: {
			async getagreement() {
				const res = await JSBkhRegistrationAgreement(61)
				this.html = res.data.content
			}
		},
	};
</script>

<style scoped>
	.agreement {
		margin: 10px 10px;
	}
</style>
